<template>
  <component
    :is="componentName"
    :component-data="componentData"
    :key="index"
    @updated="$emit('updated')"
  />
</template>

<script>
import Unknown from './TypeUnknown.vue'
import Speaking from '@core/layouts/components/breaking-components/DeepCatchUp/DeepCatchUp.vue'
import Listening from "@core/layouts/components/breaking-components/listening/TopicCard.vue";
import Vocab from './TypeVocab.vue'
import WordConnect from './TypeWordconnect.vue'
import PictureWord from './TypePictureWord.vue'
import WordPronun from './TypeWordPronunciation.vue'
import Grammar from './TypeGrammar.vue'
export default {
  name: "StageTypeDetail",
  components: {
    "stage-type-1": Speaking,
    "stage-type-2": Listening,
    "stage-type-3": Vocab,
    "stage-type-4": WordConnect,
    "stage-type-5": PictureWord,
    "stage-type-6": WordPronun,
    "stage-type-7": Grammar,
    "unknown-type": Unknown,
  },
  props: {
    componentData: { type: Object, required: true },
  },
  data() {
    return {
      index: 1
    }
  },
  computed: {
    componentName() {
      let name = `stage-type-` + this.componentData.type;
      let localComponents = Object.keys(this.$options.components);
      return localComponents.includes(name) ? name : "unknown-type";
    },
  },
  watch: {
    'componentData.content'() {
      this.index++
    }
  },
};
</script>
